import React from 'react'
import './Menu.scss'
import useNoBodyScrollbar from '../../../hooks/hideScrollbar.hook'
import {navbarData} from '../navbar/Navbar.data'

const Menu = ({romana}: { romana: any }) => {
    useNoBodyScrollbar()
    const navbar = navbarData(romana)

    return (
        <div className={'agape-menu'}>
            <div className='links'>
                {navbar.labels.map(items =>
                    <a key={romana ? items['ro'] : items['de']} href={items.link}
                       className="menu-link">{romana ? items['ro'] : items['de']}</a>
                )}
            </div>
        </div>
    )
}

export default Menu
